import React, { useRef, useEffect } from 'react';
import styles from './timerPanel.css';
import Timer from './timer/Timer';

/***********************************************************************************************************************
 *
 * @param question
 * @param statisticsPopup
 * @param contentColor
 * @param setEventSound
 * @returns {*}
 * @constructor
 **********************************************************************************************************************/
const TimerPanel = React.memo( ( { question, statisticsPopup, contentColor, setEventSound } ) => {
    const topLineRef = useRef( null );

    useEffect( () => {
        const size = window.matchMedia( '(max-width: 420px)' );
        changeTopPanel( size );
        size.addEventListener( 'resize', changeTopPanel );
    }, [] );

    const changeTopPanel = size => {
        if ( size.matches ) {
            if ( topLineRef !== null && topLineRef.style ) {
                topLineRef.style.backgroundColor = contentColor.type === 'dark' ? '#fff' : '#535353';
            }
        } else {
            if ( topLineRef !== null && topLineRef.style ) {
                topLineRef.style.backgroundColor = contentColor.overlay;
            }
        }
    };

    return (
        <div ref={ topLineRef } className={ styles.wrapper }
             style={ { backgroundColor: contentColor.overlay, color: contentColor.dark } }>
            <Timer
                setEventSound={ setEventSound }
                question={ question }
                statisticsPopup={ statisticsPopup }
            />
        </div>
    );
} );

export default TimerPanel;